import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ExternalLink } from 'lucide-react';
import { eventos, bannersRotativos } from '../mock';

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % eventos.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % bannersRotativos.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % eventos.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + eventos.length) % eventos.length);
  };

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Carousel */}
          <div className="lg:col-span-2 relative rounded-xl overflow-hidden shadow-lg bg-white border border-gray-200">
            <div className="relative h-[500px]">
              {eventos.map((evento, index) => (
                <div
                  key={evento.id}
                  className={`absolute inset-0 transition-opacity duration-700 ${
                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <div className="relative h-full">
                    <img
                      src={evento.imagen}
                      alt={evento.titulo}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                    
                    <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                      <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium mb-3">
                        {evento.categoria}
                      </span>
                      <h2 className="text-3xl font-bold mb-3 leading-tight">
                        {evento.titulo}
                      </h2>
                      <p className="text-gray-100 text-sm mb-4 line-clamp-2 max-w-3xl">
                        {evento.descripcion}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-gray-300">{evento.fecha}</span>
                        <button className="px-5 py-2 bg-[#8B1538] text-white rounded-lg text-sm font-medium hover:bg-[#6B0F2A] transition-colors flex items-center gap-2">
                          Leer Más
                          <ExternalLink className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg transition-all backdrop-blur-sm"
            >
              <ChevronLeft className="h-6 w-6 text-gray-800" />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg transition-all backdrop-blur-sm"
            >
              <ChevronRight className="h-6 w-6 text-gray-800" />
            </button>

            {/* Indicators */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
              {eventos.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`h-2 rounded-full transition-all ${
                    index === currentSlide ? 'w-8 bg-white' : 'w-2 bg-white/50'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Side Banners */}
          <div className="space-y-6">
            {/* Rotating Banner */}
            <div className="relative h-[240px] rounded-xl overflow-hidden shadow-lg bg-white border border-gray-200">
              {bannersRotativos.map((banner, index) => (
                <div
                  key={banner.id}
                  className={`absolute inset-0 transition-opacity duration-700 ${
                    index === currentBanner ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <div className="relative h-full">
                    <img
                      src={banner.imagen}
                      alt={banner.titulo}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                      <h3 className="text-sm font-bold mb-2 leading-tight">
                        {banner.titulo}
                      </h3>
                      <button className="px-4 py-1.5 bg-[#8B1538] text-white rounded-md text-xs font-medium hover:bg-[#6B0F2A] transition-colors">
                        Consultar
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Static Banner */}
            <div className="h-[240px] rounded-xl overflow-hidden shadow-lg bg-gradient-to-br from-slate-100 to-gray-200 border border-gray-200 p-6 flex flex-col justify-center items-center text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-full flex items-center justify-center mb-4 shadow-md">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Reemplacamiento 2025
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Realiza tu trámite de forma rápida y segura
              </p>
              <button className="px-5 py-2 bg-[#8B1538] text-white rounded-lg text-sm font-medium hover:bg-[#6B0F2A] transition-colors">
                Realizar Trámite
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;